<h3>Export Les Libraires</h3>
<div class="container-fluid">
  <div class="row">
    <div class="col-8">
      <div class="table-responsive">
        <table class='table table-sm text-center'>
          <thead>
            <tr>
              <th>Statut</th>
              <th>Début</th>
              <th>Fin</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="!status">
              <td colspan="3">
                Informations de synchronization indisponible
              </td>
            </tr>
            <tr *ngIf="status">
              <td>
                <span class="badge badge-success" *ngIf="status.synchronizationEnd && !status.error">
                  Complété
                </span>
                <span 
                  class="badge badge-warning" 
                  *ngIf="!status.synchronizationEnd && !status.error"
                >
                  En cours
                </span>
                <button 
                  class="btn btn-sm btn-danger" 
                  *ngIf="status.error" 
                  (click)="openErrorMessage(status.errorDetails)"
                >
                  Erreur
                </button>
              </td>
              <td>{{ status.synchronizationStart | date:'yyyy-MM-dd HH:mm:ss' }}</td>
              <td>{{ status.synchronizationEnd | date:'yyyy-MM-dd HH:mm:ss' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="col-4 text-center">
      <button class="btn btn-primary" (click)="exportInventory()">
        Exporter l'inventaire
      </button>
    </div>
  </div>
</div>

<ng-template #modal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Erreur shopify</h4>
    <button type="button" class="close" (click)="modal.dismiss()">
      <span>&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <pre>{{ errorToDisplay }}</pre>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close()">Fermer</button>
  </div>
</ng-template>